// Auto-generated from gen_ce_info_and_maps.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { CeInfoType } from '../types/ce';

const data: CeInfoType = {
  'AcesHigh': {
    'directorId': '1D2',
    'name': {
      'cn': '新型飞行型魔导装甲——加百列',
      'de': 'Gabriel, die stählerne Schwinge',
      'en': 'Aces High',
      'fr': 'Force divine',
      'ja': '新型飛行型魔導アーマー「ガブリエル」',
      'ko': '신형 비행 마도 아머 \'가브리엘\'',
      'tc': '新型飛行型魔導裝甲——加百列',
    },
  },
  'AndTheFlamesWentHigher': {
    'directorId': '1D3',
    'name': {
      'cn': '老练魔法师——铁胆狱火萨托瓦尔',
      'de': 'Sartauvoir Eisenfeuer',
      'en': 'And the Flames Went Higher',
      'fr': 'L\'envol du phénix',
      'ja': '老練の魔道士「鉄火のサルトヴォアール」',
      'ko': '노련한 마도사 \'쇳불의 사르토부아르\'',
      'tc': '老練魔道士——鐵膽獄火薩托瓦爾',
    },
  },
  'BeastOfMan': {
    'directorId': '1DB',
    'name': {
      'cn': '百兽之王——兽王莱昂',
      'de': 'Lyon der Bestienkönig',
      'en': 'Beast of Man',
      'fr': 'Le Roi bestial',
      'ja': '百獣使い「獣王ライアン」',
      'ko': '백수의 왕 \'마수왕 라이언\'',
      'tc': '百獸之王——獸王萊昂',
    },
  },
  'KillItWithFire': {
    'directorId': '1D4',
    'name': {
      'cn': '腐烂蔬菜——皮里福尔',
      'de': 'Peeriefool, das faule Gemüse',
      'en': 'Kill It with Fire',
      'fr': 'Grandeur et pestilence',
      'ja': '腐乱野菜「ピーリフール」',
      'ko': '썩은 야채 \'피어리풀\'',
      'tc': '腐爛蔬菜——皮里福爾',
    },
  },
  'MetalFoxChaos': {
    'directorId': '1CB',
    'name': {
      'cn': '钢铁魔兽——达因斯莱瓦',
      'de': 'Dáinsleif, Bestie aus Eisen',
      'en': 'Metal Fox Chaos',
      'fr': 'Le guerrier de métal',
      'ja': '鋼鉄の魔獣「ダーインスレイヴ」',
      'ko': '강철 마수 \'다인슬라이프\'',
      'tc': '鋼鐵魔獸——達因斯萊瓦',
    },
  },
  'PatriotGames': {
    'directorId': '1D1',
    'name': {
      'cn': '据点防卫魔导兵器——爱国者',
      'de': 'Verteidigungsmaschine Patriot',
      'en': 'Patriot Games',
      'fr': 'Les fusils du patriote',
      'ja': '拠点防衛魔導兵器「パトリオット」',
      'ko': '거점 방위 병기 \'패트리어트\'',
      'tc': '據點防衛魔導兵器——愛國者',
    },
  },
  'RiseOfTheRobots': {
    'directorId': '1DF',
    'name': {
      'cn': '新型铁巨人——魔导劳工X式',
      'de': 'Im Schatten von Modell X',
      'en': 'Rise of the Robots',
      'fr': 'Le soulèvement des machines',
      'ja': '新たなる鉄巨人「魔導レイバーX型」',
      'ko': '새로운 철거인 \'마도 노동자 X형\'',
      'tc': '新型鐵巨人——魔導勞工X式',
    },
  },
  'TheBattleOfCastrumLacusLitore': {
    'directorId': '1D7',
    'name': {
      'cn': '帝国湖岸堡攻城战',
      'de': 'Sturm auf Castrum Lacus Litore',
      'en': 'The Battle of Castrum Lacus Litore',
      'fr': 'Assaut sur Castrum Lacus Litore',
      'ja': 'カストルム・ラクスリトレ攻城戦',
      'ko': '카스트룸 라쿠스리토레 공성전',
      'tc': '帝國湖岸堡攻城戰',
    },
  },
  'TheBayingOfTheHounds': {
    'directorId': '1CC',
    'name': {
      'cn': '战争妖犬——恐惧妖犬',
      'de': 'Die drei Mäuler des Canis dirus',
      'en': 'The Baying of the Hound(s)',
      'fr': 'Le chien des enfers',
      'ja': '戦争の妖犬「カニスディルス」',
      'ko': '전쟁 요마견 \'카니스 디루스\'',
      'tc': '戰爭妖犬——恐懼妖犬',
    },
  },
  'TheFinalFurlong': {
    'directorId': '1D5',
    'name': {
      'cn': '怨念死灵——地生人',
      'de': 'Spartoi der Gefürchtete',
      'en': 'The Final Furlong',
      'fr': 'Menace spectrale',
      'ja': '怨念の死霊「スパルトイ」',
      'ko': '원념의 사령 \'스파르토이\'',
      'tc': '怨念死靈——地浮靈',
    },
  },
  'TheFiresOfWar': {
    'directorId': '1D6',
    'name': {
      'cn': '炎兽训练师——火焰百夫队',
      'de': 'Die Flammenden Hundert',
      'en': 'The Fires of War',
      'fr': 'Brasier de guerre',
      'ja': '炎獣使い「火焔百人隊」',
      'ko': '화염마수 조련사 \'화염백인대\'',
      'tc': '炎獸訓練師——火焰百夫隊',
    },
  },
  'TheHuntForRedChoctober': {
    'directorId': '1CA',
    'name': {
      'cn': '红陆行鸟之王——红色彗星',
      'de': 'Der Rote Meteor und seine Meute',
      'en': 'The Hunt for Red Choctober',
      'fr': 'Une ruée en rouge',
      'ja': '赤チョコボのヌシ「レッドコメット」',
      'ko': '우두머리 초코보 \'붉은 혜성\'',
      'tc': '紅陸行鳥之王——紅色彗星',
    },
  },
  'TheShadowOfDeathsHand': {
    'directorId': '1CD',
    'name': {
      'cn': '黑死鸟——阿克巴巴',
      'de': 'Akbaba, Tod von oben',
      'en': 'The Shadow of Death\'s Hand',
      'fr': 'Les ailes noires de la mort',
      'ja': '黒き死鳥「アクババ」',
      'ko': '죽음의 검은 새 \'아크바바\'',
      'tc': '黑死鳥——阿克巴巴',
    },
  },
  'TrampledUnderHoof': {
    'directorId': '1CE',
    'name': {
      'cn': '邪眼妖兽——耶鲁',
      'de': 'Die bösen Blicke der Eale',
      'en': 'Trampled under Hoof',
      'fr': 'L\'œil du malin',
      'ja': '邪眼の妖獣「エアレー」',
      'ko': '마안의 요수 \'에알레\'',
      'tc': '邪眼妖獸——耶魯',
    },
  },
  'VigilForTheLost': {
    'directorId': '1D0',
    'name': {
      'cn': '高火力陆战魔导兵器——守夜',
      'de': 'Vigil, Feuerkraft hoch zehn',
      'en': 'Vigil for the Lost',
      'fr': 'Vigile de feu',
      'ja': '高火力陸戦魔導兵器「ヴィジル」',
      'ko': '고화력 육지전 마도 병기 \'비질\'',
      'tc': '高火力陸戰魔導兵器——守夜',
    },
  },
  'WhereStrodeTheBehemoth': {
    'directorId': '1DC',
    'name': {
      'cn': '战栗之角——奇尔维尼克',
      'de': 'Der untote Chlevnik',
      'en': 'Where Strode the Behemoth',
      'fr': 'Le mastodonte enragé',
      'ja': '戦慄の角「チルヴニク」',
      'ko': '전율의 뿔 \'칠레브니크\'',
      'tc': '戰慄之角——奇爾維尼克',
    },
  },
} as const;

export default data;
